import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

export const HelpTopicMarkdownStyled = styled.article.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "help-topic-markdown",
})`
  color: ${greyMui._800};
  font-size: 0.9375rem;
  line-height: 1.65;

  h1,
  h2,
  h3,
  h4 {
    color: ${greyMui._900};
    line-height: 1.3;
    margin: 1.5rem 0 0.75rem;
    font-weight: 700;
  }

  h1 {
    font-size: 1.5rem;
    margin-top: 0;
  }

  h2 {
    font-size: 1.2rem;
    padding-bottom: 0.35rem;
    border-bottom: 1px solid ${greyMui._200};
  }

  p,
  ul,
  ol {
    margin: 0.75rem 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0;
    font-size: 0.875rem;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      display: block;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }

  th,
  td {
    border: 1px solid ${greyMui._200};
    padding: 0.5rem 0.65rem;
    text-align: start;
    vertical-align: top;
  }

  th {
    background: ${greyMui._50};
    font-weight: 600;
  }

  code {
    background: ${greyMui._100};
    border-radius: 4px;
    padding: 0.1rem 0.35rem;
    font-size: 0.85em;
  }

  pre {
    background: ${greyMui._900};
    color: ${rydeColors.white};
    border-radius: 8px;
    padding: 0.85rem 1rem;
    overflow: auto;
    margin: 1rem 0;
    font-size: 0.8125rem;
  }

  pre code {
    background: transparent;
    color: inherit;
    padding: 0;
  }

  a {
    color: ${blueMui._600};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  hr {
    border: none;
    border-top: 1px solid ${greyMui._200};
    margin: 1.25rem 0;
  }

  .HelpTopicMarkdown-ImageButton {
    appearance: none;
    border: none;
    padding: 0;
    margin: 1rem 0;
    background: transparent;
    cursor: zoom-in;
    display: block;
    max-width: 100%;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgb(0 0 0 / 0.08);
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 24px rgb(0 0 0 / 0.12);
    }
  }

  .HelpTopicMarkdown-Image {
    display: block;
    max-width: 100%;
    height: auto;
  }
`;

export const HelpTopicMarkdownLightboxStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "help-topic-markdown-lightbox",
  },
)`
  .HelpTopicMarkdown-LightboxContent {
    padding: 0;
    background-color: ${greyMui._900};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .HelpTopicMarkdown-LightboxImage {
    display: block;
    max-width: 100%;
    max-height: 85vh;
    width: auto;
    height: auto;
  }
`;
